import { I18nDataItem } from 'src/app/i18n';
export enum CampaignCategoryFormMode {
  CREATE = 'CREATE',
  EDIT = 'EDIT',
}

export type CampaignCategoryItem = {
  _id: string;
  i18nData?: I18nDataItem;
  categoryNameHK: string;
  categoryNameEn: string;
  isDefault: boolean;
  order: number;
  active: boolean;
  createdBy?: string;
  updatedBy?: string;
  createdAt?: Date;
  updatedAt?: Date;
};

export type CampaignCategoryListParam = {
  name?: string;
  page: number;
  limit: number;
};

export type CampaignCategoryUpdateItem = {
  categoryNameHK?: string;
  categoryNameEn?: string;
  isDefault?: boolean;
  order?: number;
  active: boolean;
};
